import React, { Suspense, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Work from "views/work/index";
import Careers from "views/career/index";
import About from "views/about/AboutUs";
import Contact from "views/contact/Contact";
import { lazy } from "react";

// import DynamicPageRenderer from "views/DynamicPageRenderer";
// import ServiceDetailsPage from "views/ServiceDetailsPage";
import Home from "Components/Home/Home";
import Navbar from "Components/Navbar";
import Footer from "Components/Footer/FooterDiv";
import LandingPage from "views/LandingPage/LandingPage";
import Banner from "Components/Home/Banner";
import { ToastContainer } from "react-toastify";

// import WHYCHOOSEUS from "Components/whyChooseus/whyChooseus";
import WHYCHOOSEUS from "Components/WHYCHOOSEUS/WHYCHOOSEUS";
import HappyClient from "Components/HappyClient/HappyClient";
import BlogDetail from "views/BlogDetail";
import DraftEditor from "Components/Admin/Blog/Editor/DraftEditor";
import AdminNavbar from "Components/Admin/AdminNavbar/Navbar";
import AdminJobPostForm from "Components/Admin/Job/AdminJobPostForm";
import Login from "Components/Admin/Login/Login";
import BlogPost from "Components/Admin/Blog/Editor/BlogPost";
import JobPost from "Components/Admin/Job/JobPost";
import Blogs from "views/Blogs/Blogs";
import BlogListPage from "views/ExternalBlog/BlogListPage";
import BlogDetailPage from "views/ExternalBlog/BlogDetailPage";
import AdminLogin from "Components/Admin/Login/AdminLogin";
import { Toaster } from "react-hot-toast";
import Board from "Components/Board/Board";
import ProductsPage from "Components/ProductsPage/ProductsPage";
import Leaders from "Components/Leaders/Leaders";
import BlogPostingByLexical from "Components/BlogPosting/BlogPostingByLexical";
import BlogEdit from "Components/Admin/Blog/Editor/BlogPost";
import BookDemoPage from "views/BookDemo/BookDemoPage";
import DemoRequests from "Components/Admin/DemoRequests/DemoRequests";

const DynamicPageRenderer = lazy(() => import("views/DynamicPageRenderer"));
const ServiceDetailsPage = lazy(() => import("views/ServiceDetailsPage"));
const ManufacturingPage = lazy(() => import("views/manufacturing/ManufacturingPage"));
const BFSIPage = lazy(() => import("views/manufacturing/BFSIPage"));
const HealthcarePage = lazy(() => import("views/manufacturing/HealthcarePage"));
const TechnologyPracticesPage = lazy(() => import("views/manufacturing/TechnologyPracticesPage"));
const CommunicationsMediaRetailPage = lazy(() => import("views/manufacturing/CommunicationsMediaRetailPage"));
const TalentIntelligencePage = lazy(() => import("views/manufacturing/TalentIntelligencePage"));
const BusinessTransformationAdvisoryPage = lazy(() => import("views/manufacturing/BusinessTransformationAdvisoryPage"));
const ProductEngineeringPage = lazy(() => import("views/manufacturing/ProductEngineeringPage"));
const DataAiAutomationPage = lazy(() => import("views/manufacturing/DataAiAutomationPage"));
const CloudDevOpsSecurityPage = lazy(() => import("views/manufacturing/CloudDevOpsSecurityPage"));
const EmbeddedMobilityPage = lazy(() => import("views/manufacturing/EmbeddedMobilityPage"));
// function ProtectedRoutes({ children }) {
//   const token = localStorage.getItem('token')

//   if (!token) return false
//   const decoded = JSON.parse(atob(token.split('.')[1])); // Decode token to get role
//   return decoded.role === 'admin';
// }
const ProtectedRoutes = ({ children }) => {
  const token = localStorage.getItem("token"); // Check for token in localStorage

  if (!token) {
    // If no token, redirect to admin login
    return <Navigate to="/admin/adminlogin" replace />;
  }
  return children; // If token exists, render the children components
};

function PublicLayout() {
  return (
    <div>
      {/* <ScrolltoTop/> */}
      <Navbar />
      <Routes>
        <Route path="/gcc" element={<LandingPage />} />
        <Route
          path="/"
          element={
            <>
              <div id="/">
                <Home />
              </div>
              <div id="about">
                <About />
              </div>
              <Leaders />
              <Banner />
              <div id="why">
                <WHYCHOOSEUS />
              </div>
              <HappyClient />
              <div id="contact">
                <Contact />
              </div>
            </>
          }
        />
        <Route path="/book-demo" element={<BookDemoPage />} />
        <Route
          path="/services/:section/:pageTitle"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <DynamicPageRenderer />
            </Suspense>
          }
        />
        <Route
          path="/services/:section/:pageTitle/:cardTitle"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <ServiceDetailsPage />
            </Suspense>
          }
        />
        <Route path="/services/solutions/talent-intelligence" element={<Suspense fallback={<div>Loading...</div>}><TalentIntelligencePage /></Suspense>} />
        <Route path="/services/solutions/business-transformation-advisory" element={<Suspense fallback={<div>Loading...</div>}><BusinessTransformationAdvisoryPage /></Suspense>} />
        <Route path="/services/solutions/product-engineering" element={<Suspense fallback={<div>Loading...</div>}><ProductEngineeringPage /></Suspense>} />
        <Route path="/services/solutions/data-ai-analytics" element={<Suspense fallback={<div>Loading...</div>}><DataAiAutomationPage /></Suspense>} />
        <Route path="/services/solutions/cloud-devops-security" element={<Suspense fallback={<div>Loading...</div>}><CloudDevOpsSecurityPage /></Suspense>} />
        <Route path="/services/solutions/embedded-mobility" element={<Suspense fallback={<div>Loading...</div>}><EmbeddedMobilityPage /></Suspense>} />
        <Route path="/work" element={<Work />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/industries/manufacturing-industrial-energy" element={<Suspense fallback={<div>Loading...</div>}><ManufacturingPage /></Suspense>} />
        <Route path="/industries/bfsi" element={<Suspense fallback={<div>Loading...</div>}><BFSIPage /></Suspense>} />
        <Route path="/industries/healthcare-life-sciences" element={<Suspense fallback={<div>Loading...</div>}><HealthcarePage /></Suspense>} />
        <Route path="/industries/communications-media-retail" element={<Suspense fallback={<div>Loading...</div>}><CommunicationsMediaRetailPage /></Suspense>} />
        <Route path="/industries/automotive-aerospace-defence-technology" element={<Suspense fallback={<div>Loading...</div>}><TechnologyPracticesPage /></Suspense>} />

        {/* Backward Compatibility Redirects */}
        <Route path="/manufacturing" element={<Navigate to="/industries/manufacturing-industrial-energy" replace />} />
        <Route path="/bfsi" element={<Navigate to="/industries/bfsi" replace />} />
        <Route path="/healthcare" element={<Navigate to="/industries/healthcare-life-sciences" replace />} />
        <Route path="/tech-engineering" element={<Navigate to="/industries/automotive-aerospace-defence-technology" replace />} />
        <Route path="/insights" element={<Blogs />} />
        <Route
          path="/blog-posting-by-lexical"
          element={<BlogPostingByLexical />}
        />
        {/* <Route path="/insights/:slug" element={<BlogDetail />}/> */}
        {/* <Route path="/insights/:blogtitle" element={<BlogDetail />}/> */}
        <Route path="/insights/:slug" element={<BlogDetail />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/careers" element={<Careers />} />
        {/* <Route path="/about" element={<About />} /> */}
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

function AdminLayout() {
  const [isSuccessFullLogin, setIsSuccessFullLogin] = useState(true);
  return (
    <>
      <div>
        <AdminNavbar
          isSuccessFullLogin={isSuccessFullLogin}
          setIsSuccessFullLogin={setIsSuccessFullLogin}
        />
        <Routes>
          {/* <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoutes>
              <AdminDashboard />
            </ProtectedRoutes>
          }
        /> */}

          <Route
            path="/"
            element={
              <ProtectedRoutes>
                <AdminLogin />
              </ProtectedRoutes>
            }
          />

          {/* <Route
            path="/blog-posting"
            element={
              <ProtectedRoutes>
                <DraftEditor />
                <Navigate to="https://blog.provaantech.com" replace />
              </ProtectedRoutes>
            }
          /> */}

          <Route
            path="/job-posting"
            element={
              <ProtectedRoutes>
                <AdminJobPostForm />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/demo"
            element={
              <ProtectedRoutes>
                <Board />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/job-edit"
            element={
              <ProtectedRoutes>
                <JobPost />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/blog-edit"
            element={
              <ProtectedRoutes>
                <BlogPost />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/demo-requests"
            element={
              <ProtectedRoutes>
                <DemoRequests />
              </ProtectedRoutes>
            }
          />
          <Route path="/adminlogin" element={<AdminLogin />} />
          {/* <Route path="/login" element={<Login setIsSuccessFullLogin={setIsSuccessFullLogin} />} /> */}
        </Routes>

        {/* <Routes>
       
        <Route path="/blog-posting" element={<DraftEditor />} />
        <Route path="/job-posting" element={<AdminJobPostForm />} />
        <Route path="/job-edit" element={<JobPost />} />
        <Route path="/blog-edit" element={<BlogPost />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/login" element={<Login setIsSuccessFullLogin={setIsSuccessFullLogin} />} />
      </Routes> */}
      </div>
    </>
  );
}

function App() {
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        style={{ zIndex: 99999999 }}
      />

      <Routes>
        {/* Public Routes */}
        <Route path="/*" element={<PublicLayout />} />

        {/* Admin Routes */}
        <Route path="/admin/*" element={<AdminLayout />} />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;
